import React, { useState, useEffect, useCallback } from "react";
import { EmployeeNavbar } from "../reusedcomponent/navbar";
import ViewDetailModal from "../modals/view_details";
import { ApiService } from "../../../../services/ApiService";
import { employeeMngtThunk } from "../../../../store/actions/employeemanagement/employee.thunk";
import { useDispatch, useSelector } from "react-redux";
import { PageBody } from "../../../../components/loader";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";
import { constant } from "../../../../Constants/constant";

export const EmployeeWhoIsOut = () => {
  const [modalopen, Setmodalopen] = useState(false);
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const { whoIsOut } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();

  function toggle() {
    Setmodalopen(!modalopen);
  }

  console.log("dd", whoIsOut);

  const getInActiveEmployees = useCallback(async () => {
    updateLoader(true, "Getting who is out employees");
    await dispatch(employeeMngtThunk.getWhoIsOutEmployees());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getInActiveEmployees();
  }, []);

  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <EmployeeNavbar />
        {/* <ViewDetailModal toggle={toggle} modal={modalopen} /> */}
        <div className="row container">
          {whoIsOut.map((user, i) => (
            <div className="col-md-3" key={i}>
              <div className="text-center card-box-two">
                <div className="dropdown pull-right">
                  <a
                    href="employee-management.html#"
                    className="dropdown-toggle card-drop arrow-none"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <h3 className="m-0 text-muted">
                      <i className="fas fa-ellipsis-v"></i>
                    </h3>
                  </a>
                  <div
                    className="dropdown-menu dropdown-menu-right"
                    aria-labelledby="btnGroupDrop1"
                  >
                    <a
                      className="dropdown-item"
                      href="employee-management.html#"
                    >
                      Edit
                    </a>
                    <a
                      className="dropdown-item"
                      href="employee-management.html#"
                    >
                      Deactivate
                    </a>
                  </div>
                </div>

                <div className="clearfix"></div>
                <div className="member-card">
                  <div className="thumb-xl member-thumb m-b-10 mx-auto">
                    <img
                      src={`${constant.ImgURL}/uploads/${user.profile_picture}`}
                      className="rounded-circle img-thumbnail"
                      alt="profile"
                    />
                    <i
                      className="mdi mdi-star-circle member-star text-danger"
                      title="verified user"
                    ></i>
                  </div>

                  <div className="">
                    <h4 className="m-b-5 font-18">
                      {user.first_name + " " + user.last_name}
                    </h4>
                    <p className="text-muted">
                      {user.job_title !== null ? user.job_title.name : ""}{" "}
                      <span> || </span> <span> {user.office}</span>
                    </p>
                  </div>

                  <p className="text-muted font-13">{user.mobile_number}</p>
                  <p className="text-muted font-13">Active</p>
                  {/* <a
                                href="#myModal"
                                data-toggle="modal"
                                data-toggle="modal"
                            > */}
                  {/* <button
                    type="button"
                    className="btn btn-primary m-t-20 btn-rounded btn-bordered waves-effect w-md waves-light"
                    onClick={toggle}
                  >
                    View details
                  </button> */}
                  {/* </a> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/employees/who_is_out.js